import type {TranslateLoader} from '@ngx-translate/core'
import {type Observable, from} from 'rxjs'
import {catchError} from 'rxjs/operators'
import {DragAndDropDirective} from '@cart/src/app/directives/drag-and-drop.directive'
import {FabCartScrollDirective} from '@cart/src/app/directives/fab-cart-scroll.directive'
import {HideHeaderDirective} from '@cart/src/app/directives/hide-header.directive'
import {CapitalizePipe} from '@cart/src/app/pipes/capitalize.pipe'
import {RouterOutletsPipe} from '@cart/src/app/pipes/router-outlets.pipe'
import {AutoResizeTextareaDirective} from './directives/auto-resize-textarea.directive'
import {DebounceDirective} from './directives/debounce.directive'
import {FallbackDirective} from './directives/fallback.directive'
import {DateFormatPipe} from './pipes/date-format-pipe.pipe'
import {DecodeUriPipe} from './pipes/decode-uri.pipe'
import {MyCurrencyPipe} from './pipes/my-currency.pipe'
import {ReplacePipe} from './pipes/replace.pipe'
import {SafePipe} from './pipes/safe.pipe'
import {TruncatePipe} from './pipes/truncate.pipe'
import {UveTranslatePipe} from './pipes/uve-translate.pipe'

declare let System: ISystem

/**
 * WebpackTranslateLoader class for loading translation files.
 * Used by TranslateModule configuration in app-shared.module.ts
 */
export class WebpackTranslateLoader implements TranslateLoader {
  getTranslation(lang: string): Observable<any> {
    try {
      return from(import(`../assets/i18n/locales/${lang}/uve-cart-${lang}.json`))
    } catch {
      return from(import(`../assets/i18n/locales/en/uve-cart-en.json`))
    }
  }
}

interface ISystem {
  import(request: string): Promise<any>
}

export const SHARED_DIRECTIVES_PIPES = [
  // Standalone directives
  DateFormatPipe,
  FallbackDirective,
  DragAndDropDirective,
  HideHeaderDirective,
  AutoResizeTextareaDirective,
  FabCartScrollDirective,
  DebounceDirective,
  // Standalone pipes
  SafePipe,
  MyCurrencyPipe,
  ReplacePipe,
  DecodeUriPipe,
  TruncatePipe,
  UveTranslatePipe,
  RouterOutletsPipe,
  CapitalizePipe,
]
